import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aa825c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-shipping" }
const _hoisted_2 = { class: "store flex-bwn-ter" }
const _hoisted_3 = {
  key: 0,
  class: "ml_20"
}
const _hoisted_4 = { class: "address flex-bwn" }
const _hoisted_5 = { class: "address-info" }
const _hoisted_6 = { class: "rel" }
const _hoisted_7 = {
  key: 0,
  class: "tip abs",
  style: {"left":"9px","bottom":"-32px","width":"300px"}
}
const _hoisted_8 = {
  key: 1,
  class: "tip",
  style: {"margin-left":"10px"}
}
const _hoisted_9 = {
  key: 0,
  class: "flex"
}
const _hoisted_10 = {
  key: 1,
  class: "flex"
}
const _hoisted_11 = { class: "address flex-bwn" }
const _hoisted_12 = { class: "address-info" }
const _hoisted_13 = { class: "rel" }
const _hoisted_14 = {
  key: 0,
  class: "tip abs",
  style: {"left":"9px","bottom":"-32px","width":"300px"}
}
const _hoisted_15 = {
  key: 0,
  class: "flex"
}
const _hoisted_16 = {
  key: 1,
  class: "flex"
}
const _hoisted_17 = { class: "create-form" }
const _hoisted_18 = {
  key: 0,
  class: "flex",
  style: {"align-items":"flex-start","margin-bottom":"30px"}
}
const _hoisted_19 = {
  class: "flex",
  style: {"align-items":"flex-start"}
}
const _hoisted_20 = {
  key: 1,
  class: "flex",
  style: {"align-items":"flex-start","margin-top":"30px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#e83d51"} }, "* ", -1))
const _hoisted_22 = {
  key: 2,
  class: "flex",
  style: {"align-items":"flex-start","margin-top":"30px"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#e83d51"} }, "* ", -1))
const _hoisted_24 = { style: {"margin-top":"30px"} }
const _hoisted_25 = { class: "inShipConfig flex" }
const _hoisted_26 = { style: {"width":"280px"} }
const _hoisted_27 = {
  key: 0,
  class: "compute-price"
}
const _hoisted_28 = { class: "flex-ter warehouse-content" }
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/help_icon.png",
  alt: ""
}, null, -1))
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "setting-form" }
const _hoisted_33 = { class: "flex-bwn-ter" }
const _hoisted_34 = { class: "setting" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fx-1" }, null, -1))
const _hoisted_36 = { style: {"display":"flex","align-items":"center","color":"var(--el-text-color-regular)","font-size":"15px"} }
const _hoisted_37 = { style: {"margin-right":"16px"} }
const _hoisted_38 = { style: {"font-weight":"700"} }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#930303"} }, "* ", -1))
const _hoisted_41 = { class: "flex-col" }
const _hoisted_42 = {
  key: 0,
  class: "flex",
  style: {"margin":"10px 0 0 0"}
}
const _hoisted_43 = {
  key: 0,
  class: "light",
  style: {"text-decoration":"none"},
  target: "_blank",
  href: "https://static-jp.theckb.com/static-asset/client/excelTemplate/テンプレート_ 楽天.xlsx"
}
const _hoisted_44 = ["href"]
const _hoisted_45 = { style: {"width":"300px","padding":"20px 30px"} }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("，")
const _hoisted_47 = { style: {"color":"#008dde"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = { style: {"text-align":"center"} }
const _hoisted_50 = { style: {"margin":"0 10px","cursor":"pointer"} }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { style: {"width":"300px","padding":"20px 30px"} }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("，")
const _hoisted_56 = { style: {"color":"#008dde"} }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = { style: {"text-align":"center"} }
const _hoisted_59 = { style: {"text-align":"center"} }
const _hoisted_60 = { class: "flex-ter" }
const _hoisted_61 = { style: {"text-align":"center"} }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  key: 0,
  class: "zozotownTips"
}
const _hoisted_64 = {
  key: 2,
  class: "zozotownTips"
}
const _hoisted_65 = { key: 0 }
const _hoisted_66 = {
  key: 0,
  style: {"padding-top":"30px"}
}
const _hoisted_67 = ["innerHTML"]
const _hoisted_68 = { style: {"margin-top":"20px"} }
const _hoisted_69 = {
  key: 0,
  style: {"color":"#F09336"}
}

import { t } from '@/plugins/i18n'
import { ref, toRaw, computed, reactive, watch, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import type { FormInstance } from 'element-plus'
import { QuestionFilled, Close } from '@element-plus/icons-vue'
import BindAmazonSkuModal from '@/views/product/Stock/components/BindAmazonSkuModal.vue'

import confirmDialog from '@/components/common/ConfirmDialog'
import { exportFileDownload } from '@/util/useExport'

import ExpressSelect from '@/components/ExpressSelect/index.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import AppLink from '@/components/common/AppLink.vue'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import ValidateTargetPlatformSkuRepeat from './ValidateTargetPlatformSkuRepeat.vue'
import DeliveryForm from '../components/DeliveryForm.vue'
import AddProduct from '../components/AddProduct.vue'
import AddressConfig from '../components/AddressConfig.vue'
import Guide from '@/components/guide/index.vue'
// import UploadFile from '@/components/common/UploadFile.vue'
import UploadFile from '@/components/common/UploadFilePDF.vue'
import KrCustomsTip from '@/components/common/KrCustomsTip/index.vue'
import TariffConfig from '../components/TariffConfig.vue'
import EditPrintTemplate from '../components/EditPrintTemplate.vue'
import ErrorListDialog from '../components/ErrorListDialog.vue'
import PackingListConfig from '../components/PackingListConfig.vue'
import BatchEditSkuVue from '../components/BatchEditSku.vue.vue'
import ExportBtn from '../components/ExportGoods/index.vue'
import { COUNTRY } from '@/global'
import * as XLSX from 'xlsx/xlsx.mjs'
import axios from 'axios'

import { useSite, useRtfix, isD2C, expressCostPdf, useSite2Station, isKO, isEN, useSite2Code, isMultiStore, isJA, isChoiceShop } from '@/store'

import {
  createDelivery,
  productSkuEdit,
  editFileFeign,
  batchEditFileFeign,
  getCustomerProductSkuListApi,
  getAutoTransferOverseasCustomerIdsApi
} from '@/apis/inShipping'
import { pageMyInventoryList } from '@/apis/stock'
import {
  productColumns,
  productTableConfig2,
  dynamicAggregate,
  thirdWarehouseTypeDict,
  skuTemplate
} from './data'

import useForm from './useForm'
import useAddress, { getAreaTxt, getCityTxt } from './useAddress'
import useProduct from './useProduct'
import { getCustomerShop, getDefaultTemplate, getIsShowCustomsApi, getTemplate, zozotownExcelExport } from '@/apis/order'
import { useStore } from 'vuex'
import { changeCountryCodeToPhoneCode } from '@/util/useCountry'
import { Site, excelOrderTemplateHref } from '@/common/const'
import { getConfigApi, setConfigApi } from '@/apis/user'
import UploadBtn from '../components/UploadGoods/btn.vue'

// zozotown
import { validExcel, excelError, updateFormList, checkPackingStatus } from './zozotwon'
enum SENDTYPE {
  ZOZOTOWN = '4',
  LETIAN = '2',
  OTHER = '0',
  SHOPLIST = '3'
}
interface ValidateSkuRepeatParams {
  excelTable: Record<string, string>[]
  onStopUpload: () => void
}
/**
 * 校验 sku 是否重复
 * 如果重复给出二期确认弹窗
 */
interface Column {
  label?: string
  prop?: string
  align?: string
  width?: number
  slotName?: string
}
interface SortParmas {
  column: any
  order: 'ascending' | 'descending' | null
  prop: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const site = useSite()
const bindAmazonVisible = ref(false)
const rowItem = ref({})
const router = useRouter()
const store = useStore()
const stationCode = useSite2Station()
const estimateIntShip = ref('')
const route = useRoute()
const {
  form,
  rules,
  formRef,
  weight,
  // estimateIntShip,
  getEstimateIntShipInfo,
  changePrice,
  inputPrice,
  setFile,
  additionalLabelDict,
  // intShipTypeOption,
  // intShipType,
  hasLabelAdditionId,
  // templateOption,
  templatePreview
} = useForm()

const isCrossMall = computed(() => store.getters.isCrossMall)

// <!-- 其他并且是crossmall不展示 -->
const isCrossHidden = computed(() => {
  return store.getters.isCrossMall && sendType.value === '0'
})
const {
  showClearanceAddress,
  clearanceAddressConfig,
  addClearance,
  setDefaultClearanceAddress,
  openClearanceAddressVisible,
  showShippingAddress,
  shippingAddressConfig,
  addShipping,
  setDefaultShippingAddress,
  openShippingAddressVisible,
  provinces,
  selectShippingAddress,
  selectShippingAddressFn,
  selectClearanceAddress,
  selectClearanceAddressFn,
  refreshClearanceList,
  refreshShippingList,
  intShipTypeOption,
  intShipType,
  selectClearanceAddressChoice
}: Record<string, any> = useAddress(form, route.params?.wareType as string)

const {
  STableRef,
  getProductSkuList,
  addProductVisible,
  openAddProductVisible,
  handleSelection,
  delMoreRow,
  delRow,
  saveoverseaProducSku
} = useProduct(form, formRef)
const refValidateTargetPlatformSkuRepeat = ref<InstanceType<typeof ValidateTargetPlatformSkuRepeat> | null>(null)
if (route.query?.shopProductSku) {
  const shopProductSkuList = route.query.shopProductSku?.split(',')
  pageMyInventoryList(shopProductSkuList).then((res: any) => {
    form.deliverTaskDetails = res.data
      .map((e: any) => ({
        ...e,
        useable: e.availableQuantity,
        deliveryNums: e.availableQuantity
      }))
      .filter((e: any) => e.useable)
  })
}
// 发货类型
const sendType: any = ref({})
// 是否选择韩国仓
const isMultiGoods = ref(route.params?.wareType === 'KR')
// 仓库类型 中国CN  韩国KR 默认中国
const wareType = ref<string>(route.params?.wareType as string ?? 'CN')
if (route.params?.sendType) {
  sendType.value = route.params.sendType
} else {
  router.push(useRtfix('ShippingList'))
}
const isWhiteOversea = ref(false)
// 白名单用户发货类型为其他时.  默认选中贴标附加项，非必填，选了贴标必须校验绑定cross mall
const isMustNeedLabel = computed(() => {
  return isCrossHidden.value && (route.params?.sendType === '0')
})
const setoversea = () => {
  // 乐天发货2 shoplist 3 zozotown 4
  return ['2', '3', '4'].includes(sendType.value)
}
const setmark = () => {
  return ['2', '3', '4'].includes(sendType.value)
}

// 附加项不可取消
const calRule = computed(() => {
  return ['2', '3', '4'].includes(sendType.value)
})

const validateSkuRepeat = async (params: ValidateSkuRepeatParams) => {
  const { excelTable, onStopUpload } = params
  if (!refValidateTargetPlatformSkuRepeat.value?.validateTargetPlatformSKURepeat) {
    return
  }
  const site = useSite()
  // const siteCode = useSite2Code()
  // debugger
  // 校验展示 sku 重复，展示二次确认弹窗
  const res = await refValidateTargetPlatformSkuRepeat.value.validateTargetPlatformSKURepeat({
    siteStation: site,
    plat: (() => {
      if (sendType.value === SENDTYPE.LETIAN) {
        return 'letian'
      }
      if (sendType.value === SENDTYPE.ZOZOTOWN) {
        return 'zozotown'
      }
      return 'other'
    })(),
    excelTable
  })
  // false 说明需要重新上传 true 继续接下来的逻辑
  if (res === false) {
    onStopUpload()
  }
  return res
}

// 箱唛发货清单的状态控制
let mark = reactive([])
const changeMark = (file: any) => {
  mark = file.map((v: any) => {
    return {
      url: v.raw.url,
      filename: v.name
    }
  })
}
let boxInfo = reactive([])
const changeBoxInfo = (file: any) => {
  boxInfo = file.map((v: any) => {
    return {
      url: v.raw.url,
      filename: v.name
    }
  })
}
// 是否选了装箱
const matchingByAdition = computed(() => {
  return form.deliveryAdditionalList.some((item: any) =>
    [additionalLabelDict.value.need_mark_delivery_addition_id].includes(
      String(item.additionCode)
    )
  )
})
// 是否选了贴标
const matchingNeedsSku = computed(() => {
  return form.deliveryAdditionalList.some((item: any) =>
    [additionalLabelDict.value.need_label_delivery_addition_id].includes(
      String(item.additionCode)
    )
  )
})

// SKU
const SKUuploadType = ref(route.params?.sendType === '2' || route.params?.sendType === '0' ? 1 : 2)
const batchSKUfile = ref()
const customerSkuSort = reactive({
  sortedTableData: [] as any[],
  orderType: null as SortParmas['order']
})
/**
 * 总发货量
 */
const totalShipments = computed(() => {
  return form.deliverTaskDetails.reduce((pre: any, cur: any) => {
    return pre + Number(cur.deliveryNums ?? 0)
  }, 0)
})
const handleSortChange = (params: SortParmas) => {
  if (params.prop === 'customerProductMsku') {
    customerSkuSort.orderType = params.order
  }
  if (params.prop === null && params.order === null) {
    customerSkuSort.orderType = null
  }
}
const computedDeliverTaskDetails = computed(() => {
  const originTableDataSource = [...form.deliverTaskDetails ?? []]
  const list1 = originTableDataSource
  if (!customerSkuSort.orderType) {
    return list1
  }
  if (customerSkuSort.orderType === 'ascending') {
    return [...list1].sort((a: any, b: any) => {
      return (a.customerProductMsku ?? '').localeCompare(b.customerProductMsku ?? '')
    })
  }
  return [...list1].sort((a: any, b: any) => {
    return (b.customerProductMsku ?? '').localeCompare(a.customerProductMsku ?? '')
  })
})

const realColumns = computed(() => {
  const realproductColumns = [...productColumns]
  realproductColumns.forEach((item: Column, index: number) => {
    if (item.prop === 'skuFile') {
      if (sendType.value !== SENDTYPE.OTHER && sendType.value !== SENDTYPE.ZOZOTOWN) {
        item.label = t(thirdWarehouseTypeDict[sendType.value] + ' SKU')
        item.slotName = 'skuFile'
        item.slotHeadName = 'skuFileHead'
        if (SKUuploadType.value === 1 && sendType.value === '2') {
          realproductColumns.splice(index, 1)
        }
      } else if (sendType.value === SENDTYPE.ZOZOTOWN) {
        item.label = t('zozotown商品标签')
        item.slotName = 'zozotownSku'
        item.slotHeadName = 'zozotownSkuHead'
        item.width = 350
      } else {
        item.label = 'SKU'
        item.slotName = 'skuFile'
        item.slotHeadName = 'skuFileHead'
        if (!matchingNeedsSku.value || SKUuploadType.value === 1) {
          realproductColumns.splice(index, 1)
        }
      }
    }
  })
  if (isCrossHidden.value) {
    // 如果是crossmall新增2个字段 customerProductMsku
    const index = realproductColumns.findIndex(v => v.props === 'customerProductMsku')
    realproductColumns.splice(index, 0, {
      label: 'SKUコード',
      prop: 'crossMallProductSku',
      align: 'center'
    },
    {
      label: '商品名',
      prop: 'crossMallProductTitle',
      align: 'center'
    })
  }
  return realproductColumns
})
watch(
  () => form.deliverTaskDetails,
  (val) => {
    form.deliverTaskDetails.forEach((item: any) => {
      let file: any
      if (item.skuFileDTOList && item.skuFileDTOList.length > 0) {
        item.skuFileDTOList.forEach((temp: any) => {
          console.log(temp.type, sendType.value)
          if (String(temp.type) === sendType.value) {
            item.skuFile =
              [
                {
                  name: temp.name,
                  raw: {
                    url: temp.url
                  }
                }
              ] || []
          }
        })
      }
    })
    estimateIntShip.value = ''
  }
)
const changeBatchFile = (file: any) => {
  if (!file[0]) {
    batchSKUfile.value = null
    // resetBatchUpload()
    return
  }
  const reader = new FileReader()
  reader.onload = async function (e) {
    const data = e.target.result
    const workbook = XLSX.read(data, { type: 'binary' })
    interface SheetTableRow {
      /** key: column name */
      [key: string]: any
    }
    type SheetTable = SheetTableRow[]
    // 表格
    const SKUfileJson: (any) = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])
    const tableDataMapping = form.deliverTaskDetails.map((item: any) => {
      return item.productSku
    })
    const SKUfileJsonMapping: string[] = SKUfileJson.map((item: any) => {
      return item['THE CKB SKU']
    })
    // // // // // // // // // // // // // // // // // // //
    // const isContinueUpload = await validateSkuRepeat({
    //   excelTable: SKUfileJson,
    //   onStopUpload: function () {
    //     resetBatchUpload()
    //   }
    // })
    // if (isContinueUpload === false) {
    //   return
    // }
    // // // // // // // // // // // // // // // // // // //
    if (tableDataMapping.length !== SKUfileJsonMapping.length || tableDataMapping.some((t: any) => !SKUfileJsonMapping.includes(t))) {
      ElMessage.warning(t('文件SKU和商品列表SKU不一致，请检查后重新上传'))
      console.info('SKU mismatch')
      batchSKUfile.value = null
      resetBatchUpload()
      return false
    }
    const SKUfile: Record<string, any> = {}
    let fileStatus = true
    const skuName = sendType.value === '0' ? 'SKU（商品管理コード）' : '楽天SKU（商品管理コード）'
    SKUfileJson.forEach((item: any) => {
      if (!item['編號'] && !item[skuName]) {
        console.info('item data (編號/SKU（商品管理コード）) missing', item)
        fileStatus = false
      }
      if (!item['THE CKB SKU']) {
        console.info('item data (THE CKB SKU) missing', item)
        fileStatus = false
      }
      if (!item['商品名'] && !item['名称']) {
        console.info('item data (商品名/名称) missing', item)
        fileStatus = false
      }
      SKUfile[item['THE CKB SKU']] = item
    })
    if (!fileStatus) {
      batchSKUfile.value = null
      resetBatchUpload()
      ElMessage.warning(t('文件SKU和商品列表SKU不一致，请检查后重新上传'))
      return
    }
    const isContinueUpload = await validateSkuRepeat({
      excelTable: SKUfileJson,
      onStopUpload: function () {
        resetBatchUpload()
      }
    })
    if (isContinueUpload === false) {
      return
    }
    const params = form.deliverTaskDetails.map((item: any, itemIndex: any) => {
      form.deliverTaskDetails[itemIndex].coding = SKUfile[item.productSku][skuName] || SKUfile[item.productSku].編號
      form.deliverTaskDetails[itemIndex].commoditySku = SKUfile[item.productSku]['THE CKB SKU']
      form.deliverTaskDetails[itemIndex].commodityName = SKUfile[item.productSku].商品名 || SKUfile[item.productSku].名称
      return {
        url: file[0].raw.url,
        name: file[0].name,
        type: sendType.value,
        shopProductSku: item.shopProductSku,
        customerShopId: item.customerShopId,
        coding: SKUfile[item.productSku][skuName] || SKUfile[item.productSku].編號,
        commoditySku: SKUfile[item.productSku]['THE CKB SKU'],
        commodityName: SKUfile[item.productSku].商品名 || SKUfile[item.productSku].名称
      }
    })
    batchEditFileFeign(params).then((res: any) => {
      if (res.success) {
        ElMessage.success(t('上传成功'))
        batchSKUfile.value = file[0]
      }
    }).catch(() => {
    })
  }
  reader.readAsBinaryString(file[0].raw)
}
const batchUpload = ref()
const resetBatchUpload = () => {
  batchUpload.value.handleClose(0)
}

const templateVisible = ref(false)
const openTemplateVisible = () => {
  if (!templatePreview.value) return ElMessage.warning(t('请选择打印模板'))
  templateVisible.value = true
}

const submitLoading = ref(false)
const tariffConfig = ref()
const packingListConfig = ref()

const batchDeleteRow = () => {
  delMoreRow()
  estimateIntShip.value = ''
}

const submit = async (formEl: FormInstance | undefined) => {
  console.log(form)
  console.log('selectShippingAddress', selectShippingAddress)

  if (!sendType.value) {
    router.push(useRtfix('ShippingList'))
    return
  }

  // 关税
  let taxData = {}
  const hasTaxConfig = await tariffConfig.value.taxValid()
  if (!hasTaxConfig) {
    return
  }
  taxData = await tariffConfig.value.getTaxData()

  // zozotown纳品书
  let packingData = {}
  const hasPackingListConfig = await packingListConfig.value.validPackingList()
  if (!hasPackingListConfig) {
    return
  }
  packingData = await packingListConfig.value.getPackingListData()

  if (!selectClearanceAddress.value) {
    ElMessage.warning(t('请选择清关地址'))
    return
  }
  if (!selectClearanceAddress.value.email) {
    ElMessage.warning(t('请填写邮箱'))
    return
  }
  if (!selectShippingAddress.value) {
    ElMessage.warning(t('请选择收货地址'))
    return
  }
  if (!isCrossHidden.value) {
    if (SKUuploadType.value === 1 && sendType.value === '2' && !batchSKUfile.value) {
      ElMessage.warning(t('请上传SKU文件'))
      return
    }
    if (SKUuploadType.value === 1 && sendType.value === '0' && !batchSKUfile.value && matchingNeedsSku.value) {
      ElMessage.warning(t('请上传SKU文件'))
      return
    }
    if ((sendType.value === '0' && matchingNeedsSku.value && SKUuploadType.value !== 1) || (SKUuploadType.value === 2 && sendType.value === '2') || ['3'].includes(sendType.value)) {
      console.log(form.deliverTaskDetails.some((item: any) => !item.skuFile?.length))
      if (form.deliverTaskDetails.some((item: any) => !item.skuFile?.length)) {
        ElMessage.warning(t('请上传SKU文件'))
        return
      }
    }
  }

  if (!formEl) return
  if (!form.deliverTaskDetails.length) { return ElMessage.warning(t('请选择商品')) }
  if (isCrossHidden.value && !form.deliveryAdditionalList.some(v => v.additionCode === 26)) {
    await confirmDialog({
      title: t('提示'),
      text: 'ラベル貼り付けが必要かどうか、確認してください。',
      okText: t('不需要'),
      cancelText: t('需要')
    })
  }
  // zozotown
  showZozotownTips.value = true
  if (sendType.value === '4' && !hasTemplate.value) {
    ElMessage.warning(t('请先新建模板'))
    return false
  }
  if (sendType.value === '4' && (form.deliverTaskDetails.some((v: any) => !v.skuTagDTOList || !v.skuTagDTOList.length || !v.skuTagDTOList[0].tagContent))) {
    // ElMessage.warning(t('商品标签信息缺失，请补充'))
    return false
  }
  if (sendType.value === '4' && form.deliverTaskDetails.some((v: any) => !checkPackingStatus(v, printOptions.value.templateJson))) {
    // ElMessage.warning(t('商品标签信息缺失，请补充'))
    return false
  }
  formEl.validate(async (valid) => {
    if (valid) {
      if (isCrossHidden.value && form.deliveryAdditionalList.some(v => v.additionCode === 26)) {
        // 必须选择了贴标附加项
        // 校验商品是否已绑定crossmall 发送日本才校验
        let num = 0
        form.deliverTaskDetails.forEach(v => {
          if (!v.crossMallProductSku) {
            num++
          }
        })
        if (num) {
          await confirmDialog({
            title: t('提示'),
            text: t('共X个sku未关联cross mall商品，请确认是否无需贴标').replace('X', num),
            okText: t('不需要'),
            cancelText: t('需要')
          })
        }
      }
      const {
        deliveryAdditionalList,
        declarationAddress,
        receiverAddress,
        deliverTaskDetails,
        deliveryTitle,
        deliveryNums,
        intShipConfigId,
        intForwarderConfigId,
        forwarder,
        deliveryType,
        distribution,
        allIncludeFlag,
        transportType
      } = toRaw(form)
      const submitForm: any = {
        deliveryNums,
        deliveryTitle,
        deliveryType,
        distribution,
        forwarder,
        intForwarderConfigId,
        intShipConfigId,
        // 选其他则固定为false
        isOversea: route.params?.sendType !== '0',
        ...taxData,
        ...packingData,
        goodsCountry: wareType.value,
        allIncludeFlag
      }

      if (allIncludeFlag === 1) {
        submitForm.shippingType = '0'
        submitForm.forwarder = '0'
        submitForm.distribution = '0'
        submitForm.intForwarderConfigId = 0
        submitForm.transportType = transportType
      }
      //  <el-radio-group v-model="sendType" v-if="createType === 2" style="padding:10px 0">
      //   <el-radio :label="2">{{ t('乐天') }}</el-radio>
      //   <el-radio :label="3">{{ t('SHOPLIST') }}</el-radio>
      //   <el-radio :label="4">{{ t('ZOZOTOWN') }}</el-radio>
      //   <el-radio :label="0">{{ t('其他') }}</el-radio>
      // </el-radio-group>
      if (['2', '3', '4'].includes(sendType.value)) {
        submitForm.labelType = 1
      }
      if (sendType.value === '0' && matchingNeedsSku.value) {
        submitForm.labelType = 1
      }
      if (SKUuploadType.value === 1 && (sendType.value === '2' || (sendType.value === '0' && matchingNeedsSku.value))) {
        submitForm.labelType = 2
      }
      console.log('labelType', submitForm.labelType)
      // 收货地址
      submitForm.receiverAddress = {
        address: receiverAddress.address,
        // province: getAreaTxt(receiverAddress, provinces.value),
        // city: getCityTxt(receiverAddress, provinces.value),
        clubCode: receiverAddress.companyCode,
        companyName: receiverAddress.companyName,
        mobile: receiverAddress.phone,
        name: receiverAddress.receiveName,
        postalCode: receiverAddress.postalCode,
        nation: selectShippingAddress.value.nationId || '2279',
        province: selectShippingAddress.value.area,
        // 个别地址没有市保存时需要为空
        city: selectShippingAddress.value.city === '-' ? '' : selectShippingAddress.value.city,
        code: selectShippingAddress.value.nationCode || 'JP',
        countryCode: selectShippingAddress.value.countryCode,
        email: selectShippingAddress.value.email
      }
      submitForm.receiverEnglishAddress = {
        address: receiverAddress.addressEn,
        province: receiverAddress.areaEn,
        city: receiverAddress.cityEn,
        name: receiverAddress.receiveNameEn,
        nation: selectShippingAddress.value.nationCode || 'JP'
      }

      submitForm.declarationAddress = {
        address: declarationAddress.addressEn,
        province: declarationAddress.areaEn,
        city: declarationAddress.cityEn,
        clubCode: declarationAddress.companyCode,
        companyName: declarationAddress.companyNameEn,
        mobile: declarationAddress.phone,
        name: declarationAddress.receiveNameEn,
        postalCode: declarationAddress.postalCode,
        nation: declarationAddress.nationCode,
        code: declarationAddress.nationCode,
        email: declarationAddress.email,
        clearanceCode: declarationAddress.clearanceCode,
        clearanceType: declarationAddress.clearanceType
      }
      submitForm.originalDeclarationAddress = {
        address: declarationAddress.address,
        province: declarationAddress.area,
        city: declarationAddress.city,
        clubCode: declarationAddress.companyCode,
        companyName: declarationAddress.companyName,
        mobile: declarationAddress.phone,
        name: declarationAddress.receiveName,
        postalCode: declarationAddress.postalCode,
        nation: declarationAddress.nationCode,
        code: declarationAddress.nationCode,
        email: declarationAddress.email,
        clearanceCode: declarationAddress.clearanceCode,
        clearanceType: declarationAddress.clearanceType
      }

      submitForm.deliverTaskDetails = deliverTaskDetails.map((e: any) => {
        console.log(e)
        submitForm.deliveryNums += Number(e.deliveryNums)
        const barCodeUrl = e.skuFile ? e.skuFile[0].raw.url : ''
        const barCodeName = e.skuFile ? e.skuFile[0].name : ''
        let data: Record<string, any> = {}
        data = {
          deliveryNums: Number(e.deliveryNums),
          productSku: e.productSku,
          shopProductSku: e.shopProductSku,
          barCodeUrl: barCodeUrl,
          barCodeName: barCodeName
        }
        if (SKUuploadType.value === 1 && (sendType.value === '2' || (sendType.value === '0' && matchingNeedsSku.value))) {
          data.barCodeUrl = batchSKUfile.value ? batchSKUfile.value.raw.url : ''
          data.barCodeName = batchSKUfile.value ? batchSKUfile.value.name : ''
          data.commodityName = e.commodityName
          data.coding = e.coding
          data.commoditySku = e.commoditySku
        }
        return data
      })
      submitForm.deliveryAdditionalList = deliveryAdditionalList.map(
        (e: any) => ({
          additionConfigId: e.additionConfigId,
          additionId: e.additionId,
          additionCode: e.additionCode,
          ingredientsSku: e.ingredientsSku
        })
      )

      submitForm.thirdWarehouseType = Number(sendType.value)
      submitForm.packingListUrl = boxInfo
        .map((v) => {
          return v.url
        })
        .join(',')
      submitForm.boxMarkLink = mark
        .map((v) => {
          return v.url
        })
        .join(',')
      if (sendType.value === '2' && submitForm.packingListUrl === '') {
        ElMessage.warning(t('请上传装箱清单'))
        return
      }
      if (
        sendType.value === '0' &&
        matchingByAdition.value &&
        submitForm.packingListUrl === ''
      ) {
        ElMessage.warning(t('请上传装箱清单'))
        return
      }
      if (
        sendType.value === '0' &&
        matchingByAdition.value &&
        submitForm.boxMarkLink === ''
      ) {
        ElMessage.warning(t('请上传箱唛'))
        return
      }

      submitLoading.value = true
      createDelivery(submitForm)
        .then((res: any) => {
          if (res.success) {
            submitLoading.value = false
            ElMessage.success(t('国际发货创建成功'))
            store.commit('status/editing', false)
            router.push(useRtfix('ShippingList'))
          } else {
            submitLoading.value = false
          }
          // TODO 添加记录
          const configName = '国际发货-关税收取方式的默认选择'
          const configCode = {
            configName,
            sendType: route.params.sendType
          }
          const params = {
            configCode: JSON.stringify(configCode),
            configValue: submitForm.tariffType,
            configName: configName
          }
          setConfigApi(params)
        })
        .catch(() => {
          submitLoading.value = false
        })
    } else {
      console.log('false')
      return false
    }
  })
}

// 上传商品sku
const changeSkuFile = (file: any, row: any, rowIndex: any) => {
  if (file.length === 0) {
    row.skuFile = []
    return
  }
  const fileData: any = file[0].raw
  row.skuFile = file[0]
    ? [
      {
        name: fileData.name,
        raw: {
          url: fileData.url
        }
      }
    ]
    : []
  uploadSku(file[0], row)
  console.log('row.skuFile', row.skuFile)
}
const uploadSku = (event: any, row: any) => {
  submitLoading.value = true
  const params = {
    url: event.raw.url,
    name: event.name,
    type: sendType.value,
    shopProductSku: row.shopProductSku,
    customerShopId: row.customerShopId
  }
  editFileFeign(params).then((res: any) => {
    if (res.success) {
      submitLoading.value = false
      ElMessage.success(t('上传成功'))
    } else {
      submitLoading.value = false
    }
  })
}

const wareName = ref('')
getCustomerShop().then((res: any) => {
  console.log(res)
  if (res.success) {
    const warehouseList = res.data?.warehouseList ?? []
    // 表结构变了，换种形式获取仓库名称
    wareName.value = warehouseList.find((item: { warehouseCountry: string }) => item.warehouseCountry === wareType.value)?.warehouseNameTranslate
  }
})
// 是否需要弹韩国站
const isShowKrTip = ref(false)
const getKrStatus = () => {
  if (!isD2C() && isKO()) {
    // 2b 和韩国站才调用
    getIsShowCustomsApi({
      type: 2
    }).then((res: any) => {
      if (res.success) {
        isShowKrTip.value = res.data
      }
    })
  }
}
getKrStatus()
const customsCallback = () => {
  getKrStatus()
}

const getData = () => {
  if (!selectShippingAddress.value?.shopShippingAddressId) {
    ElMessage.warning(t('请选择收货地址'))
    return false
  }
  return {
    skuList: form.deliverTaskDetails.map((v: any) => {
      return {
        num: v.deliveryNums,
        productType: v.productType,
        productSku: v.productSku
      }
    }),
    countryCode: selectShippingAddress.value.nationCode ?? useSite2Code(),
    systemSource: isD2C() ? 1 : 2
  }
}
const changeExpress = (id: any, item: any) => {
  estimateIntShip.value = item.priceCny
}
const jumpExpressPrice = () => {
  const { declarationAddress, deliverTaskDetails } = toRaw(form)
  if (!deliverTaskDetails?.length) {
    ElMessage.warning(t('请选择商品'))
    return
  }
  // if (!declarationAddress.shopClearanceAddressId) {
  //   ElMessage.warning(t('当前清关地址不可用'))
  //   return
  // }
  // if (!declarationAddress.nationCode) {
  //   ElMessage.warning(t('请选择清关地址'))
  //   return
  // }
  const params = {
    membershipTemplateId: store.getters.user.membership?.membershipTemplateId,
    productParam: deliverTaskDetails.map((item: any) => {
      return {
        additionList: [],
        num: item.deliveryNums,
        productInfo: {
          productSellPrice: item.productSellPrice ?? item.unitPrice,
          productSkuImg: item.productSkuImg,
          productTitle: item.productTitle
        },
        productSellPrice: item.productSellPrice ?? item.unitPrice,
        productSku: item.productSku
      }
    }),
    shipParam: {
      countryCode: declarationAddress.nationCode ?? useSite2Code()
    }
  }
  window.localStorage.setItem(`Calculator_${isD2C() ? 1 : 2}_inshipping`, JSON.stringify(params))
  window.open('/oem/utility/InterLogistics?from=inshipping')
}
// 是否有choice商品库存
const isHaveChoiceStock = ref(false)
onMounted(() => {
  window.addEventListener('storage', shipParamChangeListner)
  // TODO 根据上一次的选择，默人初始化这次的选择
  const configName = '国际发货-关税收取方式的默认选择'
  const configCode = {
    configName,
    sendType: route.params.sendType
  }
  const params = {
    configCode: JSON.stringify(configCode),
    level: 3
  }
  getConfigApi(params).then((res) => {
    if (res.code !== '0' || [null, undefined].includes(res?.data?.configValue)) {
      tariffConfig.value.setInitTariffType(1)
      return
    }
    tariffConfig.value.setInitTariffType(Number(res.data.configValue))
  })
  getCustomerProductSkuListApi({
    goodsCountry: 'CN'
  }).then((res) => {
    isHaveChoiceStock.value = res.data?.some(v => v.allIncludeUseable && v.allIncludeUseable > 0)
  })
  getAutoTransferOverseasCustomerIdsApi({}).then((res) => {
    console.log('getAutoTransferOverseasCustomerIdsApi', res, store.getters.shopInfo?.customerId)
    isWhiteOversea.value = res.data.includes(store.getters.shopInfo?.customerId)
  })
})

onUnmounted(() => {
  window.removeEventListener('storage', shipParamChangeListner)
})

const shipParamChangeListner = (event: any) => {
  if (event.key === `Calculator_${isD2C() ? 1 : 2}_inshipping`) {
    const { shipParam } = JSON.parse(window.localStorage.getItem(`Calculator_${isD2C() ? 1 : 2}_inshipping`) ?? '{}')
    console.log('接收：', shipParam)
    if (shipParam?.intShipConfigId) {
      intShipType.value = shipParam?.intShipConfigId
      estimateIntShip.value = shipParam?.price
    }
  }
}
// zozotown
const showZozotownTips = ref(false)
const templateActionVisible = ref(false)
// 打印模板
const templateList = ref([])
const hasTemplate = ref(false)
const printOptions = ref<any>(null)
const getTemplateApi = () => {
  getTemplate({
    type: 4
  }).then((res: any) => {
    if (!res.data.length) {
      return
    }
    hasTemplate.value = true
    printOptions.value = res.data[0]
  })
  getDefaultTemplate({
    type: 4
  }).then((res: any) => {
    templateList.value = res.data
  })

  getZozotownConfig()
}
const openPrintTemplateVisible = () => {
  getTemplate({
    type: 4
  }).then((res: any) => {
    // templateList.value = res.data
    if (!res.data.length) {
      printTemplateVisible.value = true
      return
    }
    printOptions.value = res.data[0]
    printTemplateVisible.value = true
  })
}
const downloadZozoExcel = () => {
  zozotownExcelExport({ type: 4 }).then(res => {
    const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
    // const fileName = props.rowItemDetail.billNo + ' ' + dayjs().format('YYYY-MM-DD')
    const fileName = t('商品标签模板')
    const objectUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.setAttribute('style', 'display:none')
    a.setAttribute('href', objectUrl)
    a.setAttribute('download', fileName)
    a.click()
    URL.revokeObjectURL(objectUrl)
    ElMessage.success(t('导出成功'))
  })
}
const printTemplateVisible = ref(false)
const zozotownUpload = ref()
const resetZozotownUpload = () => {
  zozotownUpload.value.handleClose(0)
}
const getPrintTemplate = () => {
  getTemplateApi()
  // printOptions.value = []
}
const getExcelHeaders = () => {
  if (!printOptions.value) {
    return []
  }
  return [...new Set(printOptions.value.templateJson.filter((i: any) => i.field).map((v: any) => v.name).concat([t('商品名'), 'THE CKB SKU']))]
}
const changeZozotownFile = async (file: any) => {
  if (!file[0]) {
    resetZozotownUpload()
    return
  }

  // if (!form.deliverTaskDetails.length) {
  //   ElMessage.warning(t('请先添加商品'))
  //   resetZozotownUpload()
  //   return
  // }
  const headers = getExcelHeaders() as string[]
  // if (!headers.length) {
  //   ElMessage.warning(t('请先新建模板'))
  //   return
  // }
  const res = await validExcel({
    headers: headers,
    excel: file[0].raw,
    deliverTaskDetails: form.deliverTaskDetails,
    validateSkuRepeat
  })
  console.log(res)
  if (!res.success) {
    if (res.excelList.length > 0) {
      errorList.value = res.excelList
      errorDialogVisible.value = true
    }
    resetZozotownUpload()
    return
  }
  templateActionVisible.value = false
  form.deliverTaskDetails = await updateFormList({
    excelList: res.excelList,
    deliverTaskDetails: form.deliverTaskDetails
  })
}
// 上传excel错误信息
const errorList = ref<excelError[]>([])
const errorDialogVisible = ref(false)

// 编辑SKU
const editSkuVisible = ref(false)
const editTargetSku = ref({})
const editSku = (row: any) => {
  editSkuVisible.value = true
  editTargetSku.value = row
}
const updateDeliverTaskDetails = (editTargetSku: any) => {
  const index = form.deliverTaskDetails.findIndex((i: any) => i.productSku === editTargetSku.productSku)
  form.deliverTaskDetails[index] = editTargetSku
}
const downloadLoading = ref(false)
/** 导出商品标签pdf */
const exportGoodstagPdf = () => {
  const hasNoData = !computedDeliverTaskDetails.value?.length
  const isHasTag = computedDeliverTaskDetails.value?.some((item) => item.skuTagDTOList && item.skuTagDTOList?.length && item.skuTagDTOList[0].tagContent)
  //   如果没有商品数据，或者商品数据里面没有标签
  if (hasNoData || !isHasTag) {
    ElMessage.warning(t('无法导出，至少有一个商品标签'))
    return
  }
  const params: any = []
  computedDeliverTaskDetails.value.forEach((item) => {
    const isHasTagContent = item.skuTagDTOList && item.skuTagDTOList?.length && item.skuTagDTOList[0].tagContent
    // 只有有标签的再导出
    if (isHasTagContent) {
      params.push({ type: 4, shopProductSku: item.shopProductSku })
    }
  })
  downloadLoading.value = true
  axios({
    method: 'post',
    url: process.env.VUE_APP_URL + '/order/shop/product/sku/batchExportTagPdf',
    data: params,
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-AuthShopId': store.getters.curShop,
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    }
  }).then((res: any) => {
    // 若是数据不存在
    if (!res.data.size) {
      ElMessage.warning(t('无法导出，至少有一个商品标签'))
      return
    }
    exportFileDownload(res, { type: 'application/pdf', name: t('国際配送商品のラベルデータ') })
  }).finally(() => { downloadLoading.value = false })
}

// 获取zozotown Config
const zozotownConfig = ref({} as any)
const getZozotownConfig = async () => {
  const res = await getConfigApi({
    configCode: 'DELIVERY_TAG_BASE_PARAM',
    level: 3
  })
  console.log('res.data.configValue', res)
  if (res.success) {
    if (res?.data?.configValue) {
      zozotownConfig.value = JSON.parse(res.data.configValue)
    }
  }
}
const updateTagLogo = (url: string) => {
  zozotownConfig.value.tagLogo = url
}

getPrintTemplate()
const changeAllIncludeFlag = () => {
  form.deliverTaskDetails = []
  intShipType.value = form.allIncludeFlag === 1 ? 0 : null
  selectClearanceAddressChoice(form.allIncludeFlag)
}

const setAmazonInfo = (info) => {
  console.log('setAmazonInfo', info, rowItem.value)
  form.deliverTaskDetails = form.deliverTaskDetails.map((e: any) => {
    return (e.productSku === rowItem.value.productSku ? {
      ...e,
      crossMallProductSku: info.productSku,
      crossMallProductTitle: info.productName
    } : e)
  })
}
const openBindAmazon = (row: any) => {
  rowItem.value = row
  bindAmazonVisible.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ValidateTargetPlatformSkuRepeat, {
      ref: (_value, _refs) => {
        _refs['refValidateTargetPlatformSkuRepeat'] = _value
        refValidateTargetPlatformSkuRepeat.value = _value
      },
      onResetBatchUpload: resetBatchUpload
    }, null, 512),
    _createVNode(_component_el_form, {
      ref: (_value, _refs) => {
        _refs['formRef'] = _value
        _isRef(formRef) && (formRef.value = _value)
      },
      inline: true,
      model: _unref(form)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_unref(t)("发货类型")) + "：" + _toDisplayString(typeof sendType.value === "string"
              ? _unref(t)(_unref(thirdWarehouseTypeDict)[sendType.value])
              : _unref(t)("普通发货")) + " ", 1),
            (_unref(isMultiStore)())
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('仓库')) + " ： " + _toDisplayString(wareType.value === 'KR' ? _unref(t)('韩国仓') : _unref(t)('中国仓')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_unref(t)("清关地址")) + "： ", 1),
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_el_button, {
                  style: {"margin-left":"10px"},
                  type: "primary",
                  onClick: _unref(openClearanceAddressVisible),
                  disabled: _unref(form).allIncludeFlag === 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(showClearanceAddress) ? _unref(t)("选择清关地址") : _unref(t)("添加清关地址")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                (!_unref(selectClearanceAddress))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)("需要填写清关地址")), 1))
                  : _createCommentVNode("", true),
                (_unref(selectClearanceAddress) && !_unref(selectClearanceAddress)?.email)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)("请填写邮箱")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_unref(showClearanceAddress))
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.receiveName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.companyName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.companyCode), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(changeCountryCodeToPhoneCode)(_unref(selectClearanceAddress)?.countryCode)) + " " + _toDisplayString(_unref(selectClearanceAddress).phone), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(showClearanceAddress))
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.countryName || '日本'), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.provinceName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.cityName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.address), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.postalCode), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.email), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_unref(t)("收货地址")) + "： ", 1),
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_el_button, {
                  style: {"margin-left":"10px"},
                  type: "primary",
                  onClick: _unref(openShippingAddressVisible)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(showShippingAddress) ? _unref(t)("选择收货地址") : _unref(t)("添加收货地址")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (!_unref(selectShippingAddress))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(t)("需要填写收货地址")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_unref(showShippingAddress))
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(_unref(selectShippingAddress)?.receiveName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectShippingAddress)?.companyName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectShippingAddress)?.companyCode), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(changeCountryCodeToPhoneCode)(_unref(selectShippingAddress)?.countryCode) ||
              _unref(selectShippingAddress)?.countryCode) + " " + _toDisplayString(_unref(selectShippingAddress)?.phone), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(showShippingAddress))
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                  _createElementVNode("span", null, _toDisplayString(_unref(selectShippingAddress)?.countryName || '日本'), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectShippingAddress)?.provinceName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectShippingAddress)?.cityName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectShippingAddress)?.address), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectShippingAddress)?.postalCode), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          (wareType.value !== 'KR' && isHaveChoiceStock.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('发货类型'),
                  prop: "deliveryTitle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _unref(form).allIncludeFlag,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).allIncludeFlag) = $event)),
                      onChange: changeAllIncludeFlag
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('一价全包商品发货')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('普通商品发货')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('国际发货标题'),
              prop: "deliveryTitle",
              rules: _unref(rules).deliveryTitle
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(form).deliveryTitle,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).deliveryTitle) = $event)),
                  maxlength: 100
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('发货附加项')
            }, {
              default: _withCtx(() => [
                _createVNode(DeliveryForm, {
                  additionalList: _unref(form).deliveryAdditionalList,
                  "onUpdate:additionalList": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).deliveryAdditionalList) = $event)),
                  "is-mark": setmark(),
                  "is-oversea": setoversea(),
                  dict: _unref(additionalLabelDict),
                  calRule: _unref(calRule),
                  countryCode: wareType.value,
                  defaultLabel: _unref(isMustNeedLabel)
                }, null, 8, ["additionalList", "is-mark", "is-oversea", "dict", "calRule", "countryCode", "defaultLabel"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode(PackingListConfig, {
            ref: (_value, _refs) => {
              _refs['packingListConfig'] = _value
              packingListConfig.value = _value
            },
            templateList: templateList.value,
            zozotownConfig: zozotownConfig.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('商品标签模板'),
                style: {"margin-top":"20px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    onClick: openPrintTemplateVisible,
                    style: {"margin-left":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(!hasTemplate.value ? _unref(t)("新建模板") : _unref(t)("编辑模板")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["templateList", "zozotownConfig"]),
          (sendType.value === '0' && _unref(matchingByAdition))
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [
                    _hoisted_21,
                    _createTextVNode(_toDisplayString(_unref(t)("箱唛")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(UploadFile, {
                      onChange: changeMark,
                      limit: 100,
                      limitFile: {
              accept: '.pdf,.xls,.xlsx',
            },
                      readAuto: true,
                      bizType: "shipping"
                    }, null, 8, ["limitFile"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (sendType.value === '2' || (sendType.value === '0' && _unref(matchingByAdition)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [
                    _hoisted_23,
                    _createTextVNode(_toDisplayString(_unref(t)("装箱清单")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(UploadFile, {
                      onChange: changeBoxInfo,
                      limit: 100,
                      limitFile: {
              accept: '.pdf,.xls,.xlsx',
            },
                      readAuto: true,
                      bizType: "shipping"
                    }, null, 8, ["limitFile"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            (_unref(form).allIncludeFlag === 0)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _unref(t)('物流方式'),
                  prop: "intShipConfigId",
                  rules: _unref(rules).intShipConfigId,
                  style: {"word-break":"break-word"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(ExpressSelect, {
                            "default-express": _unref(intShipTypeOption),
                            id: _unref(intShipType),
                            "onUpdate:id": _cache[3] || (_cache[3] = ($event: any) => (_isRef(intShipType) ? (intShipType).value = $event : null)),
                            getData: getData,
                            "fee-tip": _unref(t)('请选择商品'),
                            onChange: changeExpress,
                            countryCode: wareType.value
                          }, null, 8, ["default-express", "id", "fee-tip", "countryCode"])
                        ]),
                        (wareType.value !== _unref(COUNTRY).KR)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(t)('预估物流价')) + ":" + _toDisplayString(estimateIntShip.value || '-') + _toDisplayString(_unref(t)('元')), 1))
                          : _createCommentVNode("", true),
                        (wareType.value !== _unref(COUNTRY).KR)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "compute",
                              onClick: jumpExpressPrice
                            }, _toDisplayString(_unref(t)('运费估算')) + ">", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", null, _toDisplayString(_unref(t)('店铺仓库所在地')) + ":" + _toDisplayString(wareName.value), 1),
                        (wareType.value !== _unref(COUNTRY).KR)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "light",
                              style: {"transform":"scale(.8)"},
                              target: "_blank",
                              href: _unref(expressCostPdf)()
                            }, [
                              _createTextVNode(_toDisplayString(_unref(t)('国际料金表')) + " ", 1),
                              _hoisted_30
                            ], 8, _hoisted_29))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: _unref(t)('物流方式'),
                  prop: "transportType",
                  rules: _unref(rules).transportType
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _unref(form).transportType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).transportType) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('海运')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('空运')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
          ]),
          (wareType.value !== _unref(COUNTRY).KR && _unref(form).allIncludeFlag === 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "fee-tip",
                innerHTML: _unref(t)('国际料金表提示'),
                style: {"font-size":"12px","line-height":"17px","color":"#D44345","margin":"20px 0 0 10px"}
              }, null, 8, _hoisted_31))
            : _createCommentVNode("", true)
        ]),
        _createVNode(TariffConfig, {
          ref: (_value, _refs) => {
            _refs['tariffConfig'] = _value
            tariffConfig.value = _value
          },
          allIncludeFlag: !!_unref(form).allIncludeFlag
        }, null, 8, ["allIncludeFlag"]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _unref(openAddProductVisible)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("添加商品")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                class: "btn-action",
                type: "text",
                onClick: batchDeleteRow
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("批量删除")), 1)
                ]),
                _: 1
              }),
              (_unref(isJA)() && String(sendType.value) === '4')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    loading: downloadLoading.value,
                    class: "btn-action",
                    type: "text",
                    onClick: exportGoodstagPdf
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("导出商品标签PDF")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_35,
            (isWhiteOversea.value && sendType.value === '0')
              ? (_openBlock(), _createBlock(ExportBtn, {
                  key: 0,
                  data: _unref(computedDeliverTaskDetails),
                  isCrossMall: _unref(isCrossHidden)
                }, null, 8, ["data", "isCrossMall"]))
              : _createCommentVNode("", true),
            _createVNode(UploadBtn, {
              onSubmit: _unref(getProductSkuList),
              sendType: sendType.value,
              isChoice: _unref(form).allIncludeFlag === 1
            }, null, 8, ["onSubmit", "sendType", "isChoice"]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createTextVNode(_toDisplayString(_unref(t)('总发货数量')) + "： ", 1),
                _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(totalShipments)), 1)
              ]),
              _createVNode(_component_el_button, {
                type: "primary",
                loading: submitLoading.value,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (submit(_unref(formRef))))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("创建")), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          (!_unref(isCrossHidden))
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                ((sendType.value === '2' || (sendType.value === '0' && _unref(matchingNeedsSku))))
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      style: {"margin-top":"20px"}
                    }, {
                      label: _withCtx(() => [
                        _hoisted_40,
                        _createTextVNode(_toDisplayString(_unref(t)("商品条码上传方式")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_el_radio_group, {
                            modelValue: SKUuploadType.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((SKUuploadType).value = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { label: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("所有商品一个文件上传")), 1)
                                ]),
                                _: 1
                              }),
                              (!(isWhiteOversea.value && sendType.value === '0'))
                                ? (_openBlock(), _createBlock(_component_el_radio, {
                                    key: 0,
                                    label: 2
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)("一个商品一个文件上传")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (SKUuploadType.value === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createVNode(UploadFile, {
                                  ref: (_value, _refs) => {
                                    _refs['batchUpload'] = _value
                                    batchUpload.value = _value
                                  },
                                  onChange: _cache[7] || (_cache[7] = (file) => {
                  changeBatchFile(file)
                }
                ),
                                  limit: 1,
                                  limitFile: {
                  accept: '.xls,.xlsx',
                },
                                  readAuto: true,
                                  bizType: "shipping"
                                }, null, 8, ["limitFile"]),
                                (sendType.value === '2')
                                  ? (_openBlock(), _createElementBlock("a", _hoisted_43, "   " + _toDisplayString(_unref(t)("模板下载")), 1))
                                  : _createCommentVNode("", true),
                                (sendType.value === '0')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "light",
                                      style: {"text-decoration":"none"},
                                      target: "_blank",
                                      href: _unref(excelOrderTemplateHref)[_unref(useSite)()].shipping
                                    }, "   " + _toDisplayString(_unref(t)("模板下载")), 9, _hoisted_44))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_tooltip, {
                                  placement: "top",
                                  "hide-after": 30,
                                  effect: "light"
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_45, [
                                      _createTextVNode(_toDisplayString(_unref(t)("每一个商品需要上传一个对应的标签文件，格式为PDF，参考如下")) + " ", 1),
                                      _createElementVNode("span", null, [
                                        (sendType.value === '3')
                                          ? (_openBlock(), _createBlock(AppLink, {
                                              key: 0,
                                              to: _unref(useRtfix)('help', { query: { tab: 1, id: 95 } }),
                                              target: "_blank"
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_46,
                                                _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(t)("点击查看更多")), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["to"]))
                                          : _createCommentVNode("", true),
                                        _hoisted_48,
                                        _createElementVNode("div", _hoisted_49, [
                                          _createVNode(AppLink, {
                                            to: _unref(skuTemplate)[sendType.value],
                                            target: "_blank"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_image, {
                                                referrerPolicy: "no-referrer",
                                                src: _unref(skuTemplate)[sendType.value],
                                                alt: ""
                                              }, null, 8, ["src"])
                                            ]),
                                            _: 1
                                          }, 8, ["to"])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(t)("模板效果预览")), 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
            _isRef(STableRef) && (STableRef.value = _value)
          },
          "table-data": _unref(computedDeliverTaskDetails),
          columns: _unref(realColumns),
          showPagination: false,
          "table-config": _unref(productTableConfig2),
          onSelectionChange: _unref(handleSelection),
          onSortChange: handleSortChange
        }, {
          productMainImg: _withCtx(({ row }) => [
            _createVNode(ShoppingPreview, {
              image: row.productSkuImg || row.productMainImg || ''
            }, null, 8, ["image"])
          ]),
          productSkuInfo: _withCtx(({ row }) => [
            (row.productPropertiesName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_51, [
                  _createTextVNode(_toDisplayString(_unref(t)("商品规格")) + " ", 1),
                  (row.productType === 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(row.productPropertiesName || ''), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(((row.productPropertiesName || '').split(';') || []).map((e) =>
                (e.replace(/[+-]?\d+:[+-]?\d+:/, '') || '').split(':')[1] ?? '').join(';')), 1))
                ]))
              : _createCommentVNode("", true)
          ]),
          skuFileHead: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)(_unref(thirdWarehouseTypeDict)[sendType.value] + " SKU")) + " ", 1),
            _createVNode(_component_el_tooltip, {
              placement: "top",
              "hide-after": 30,
              effect: "light"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_54, [
                  _createTextVNode(_toDisplayString(_unref(t)("每一个商品需要上传一个对应的标签文件，格式为PDF，参考如下")) + " ", 1),
                  _createElementVNode("span", null, [
                    (sendType.value === '3')
                      ? (_openBlock(), _createBlock(AppLink, {
                          key: 0,
                          to: _unref(useRtfix)('help', { query: { tab: 1, id: 95 } }),
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_55,
                            _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(t)("点击查看更多")), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    _hoisted_57,
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(AppLink, {
                        to: _unref(skuTemplate)[sendType.value],
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_image, {
                            referrerPolicy: "no-referrer",
                            src: _unref(skuTemplate)[sendType.value],
                            alt: ""
                          }, null, 8, ["src"])
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  class: "quesIcon",
                  color: "#999"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(QuestionFilled))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          skuFile: _withCtx(({ row, rowIndex }) => [
            _createElementVNode("div", _hoisted_59, [
              _createVNode(UploadFile, {
                onChange: (file) => {
              changeSkuFile(file, row, rowIndex)
            }
            ,
                limit: 1,
                file: row.skuFile,
                readAuto: true,
                bizType: "shipping"
              }, null, 8, ["onChange", "file"])
            ])
          ]),
          zozotownSkuHead: _withCtx(() => [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('zozotown商品标签')), 1),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-left":"4px"},
                onClick: _cache[8] || (_cache[8] = ($event: any) => (templateActionVisible.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('批量导入')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          zozotownSku: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_61, [
              (!hasTemplate.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_unref(t)('请先新建模板')), 1))
                : (row.skuTagDTOList && row.skuTagDTOList.length && row.skuTagDTOList[0].tagContent)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('已存在')), 1),
                        _createVNode(_component_el_button, {
                          onClick: ($event: any) => (editSku(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('修改')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      (!_unref(checkPackingStatus)(row, printOptions.value.templateJson) && showZozotownTips.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_unref(t)('商品标签信息缺失，请补充')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      (showZozotownTips.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_unref(t)('商品标签为空，请上传标签信息')), 1))
                        : _createCommentVNode("", true)
                    ]))
            ])
          ]),
          deliveryNums: _withCtx(({ row, rowIndex }) => [
            (rowIndex > -1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  _createVNode(_component_el_form_item, {
                    style: {"margin-right":"0","margin-bottom":"30px"},
                    prop: 'deliverTaskDetails.' + rowIndex + '.deliveryNums',
                    rules: _unref(rules).deliverTaskDetails.deliveryNums(_unref(form).allIncludeFlag === 1 ? row.allIncludeUseable : row.useable)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: row.deliveryNums,
                        "onUpdate:modelValue": ($event: any) => ((row.deliveryNums) = $event),
                        max: _unref(form).allIncludeFlag === 1 ? row.allIncludeUseable : row.useable,
                        size: "small",
                        onInput: ($event: any) => (_unref(inputPrice)(row)),
                        onChange: ($event: any) => {_unref(changePrice)(row, _unref(form).allIncludeFlag); estimateIntShip.value = ''}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onInput", "onChange"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "rules"])
                ]))
              : _createCommentVNode("", true)
          ]),
          handler: _withCtx(({ scope }) => [
            _createVNode(_component_table_button, {
              title: _unref(t)('移除'),
              onClick: ($event: any) => {_unref(delRow)(scope.row.productSku); estimateIntShip.value = ''}
            }, null, 8, ["title", "onClick"]),
            (!scope.row.crossMallProductSku && _unref(isCrossHidden) && _unref(form).deliveryAdditionalList.some(v => v.additionCode === 26))
              ? (_openBlock(), _createBlock(_component_table_button, {
                  key: 0,
                  title: _unref(t)('绑定CROSS MALL sku'),
                  onClick: ($event: any) => (openBindAmazon(scope.row))
                }, null, 8, ["title", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          useableHead: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(form).allIncludeFlag === 1 ? _unref(t)('一口价商品良品数') : _unref(t)('库存数量')), 1)
          ]),
          useable: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(form).allIncludeFlag === 1 ? row.allIncludeUseable : row.useable), 1)
          ]),
          _: 1
        }, 8, ["table-data", "columns", "table-config", "onSelectionChange"])
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(AddProduct, {
      visible: _unref(addProductVisible),
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_isRef(addProductVisible) ? (addProductVisible).value = $event : null)),
      "add-list": _unref(form).deliverTaskDetails,
      type: 1,
      onGetList: _unref(getProductSkuList),
      countryCode: wareType.value,
      allIncludeFlag: _unref(form).allIncludeFlag,
      isCrossMallGoods: _unref(isCrossHidden)
    }, null, 8, ["visible", "add-list", "onGetList", "countryCode", "allIncludeFlag", "isCrossMallGoods"]),
    _createVNode(AddressConfig, {
      visible: _unref(clearanceAddressConfig).visible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_unref(clearanceAddressConfig).visible) = $event)),
      config: _unref(clearanceAddressConfig),
      addApi: _unref(addClearance),
      setDefaultApi: _unref(setDefaultClearanceAddress),
      selectAddress: _unref(selectClearanceAddress),
      provinces: _unref(provinces),
      onRefresh: _unref(refreshClearanceList),
      onSelect: _unref(selectClearanceAddressFn),
      wareType: wareType.value
    }, null, 8, ["visible", "config", "addApi", "setDefaultApi", "selectAddress", "provinces", "onRefresh", "onSelect", "wareType"]),
    _createVNode(AddressConfig, {
      visible: _unref(shippingAddressConfig).visible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_unref(shippingAddressConfig).visible) = $event)),
      config: _unref(shippingAddressConfig),
      addApi: _unref(addShipping),
      setDefaultApi: _unref(setDefaultShippingAddress),
      selectAddress: _unref(selectShippingAddress),
      provinces: _unref(provinces),
      onRefresh: _unref(refreshShippingList),
      onSelect: _unref(selectShippingAddressFn)
    }, null, 8, ["visible", "config", "addApi", "setDefaultApi", "selectAddress", "provinces", "onRefresh", "onSelect"]),
    _createVNode(_component_el_dialog, {
      modelValue: templateVisible.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((templateVisible).value = $event)),
      "destroy-on-close": "",
      "custom-class": "templatePreview"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          style: {"padding":"20px"},
          innerHTML: _unref(templatePreview)
        }, null, 8, _hoisted_67)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Guide, { name: "create-shipping" }),
    _createVNode(KrCustomsTip, {
      visible: isShowKrTip.value,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((isShowKrTip).value = $event)),
      onSuccess: customsCallback,
      type: 2
    }, null, 8, ["visible"]),
    _createVNode(EditPrintTemplate, {
      visible: printTemplateVisible.value,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((printTemplateVisible).value = $event)),
      printOptions: printOptions.value,
      onUpdateTemplate: getTemplateApi,
      onUpdateTagLogo: updateTagLogo,
      templateList: templateList.value,
      zozotownConfig: zozotownConfig.value
    }, null, 8, ["visible", "printOptions", "templateList", "zozotownConfig"]),
    _createVNode(ErrorListDialog, {
      visible: errorDialogVisible.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((errorDialogVisible).value = $event)),
      errorList: errorList.value
    }, null, 8, ["visible", "errorList"]),
    _createVNode(BatchEditSkuVue, {
      visible: editSkuVisible.value,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((editSkuVisible).value = $event)),
      printOptions: printOptions.value,
      editTargetSku: editTargetSku.value,
      onUpdateDeliverTaskDetails: updateDeliverTaskDetails
    }, null, 8, ["visible", "printOptions", "editTargetSku"]),
    _createVNode(CommonDialog, {
      title: _unref(t)('批量导入'),
      onCancel: _cache[18] || (_cache[18] = ($event: any) => (templateActionVisible.value = false)),
      visible: templateActionVisible.value,
      "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((templateActionVisible).value = $event)),
      "append-to-body": "",
      "close-on-click-modal": false,
      width: 400
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", null, _toDisplayString(_unref(t)('请先下载商品标签模板，填写内容后再上传模板')), 1),
          _createVNode(_component_el_button, {
            onClick: downloadZozoExcel,
            disabled: !hasTemplate.value,
            style: {"margin-top":"20px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("下载商品标签模板")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (!hasTemplate.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_69, "(" + _toDisplayString(_unref(t)('请先新建模板')) + ")", 1))
            : _createCommentVNode("", true),
          _createVNode(UploadFile, {
            ref: (_value, _refs) => {
              _refs['zozotownUpload'] = _value
              zozotownUpload.value = _value
            },
            onChange: _cache[17] || (_cache[17] = (file) => {
          changeZozotownFile(file)
        }
        ),
            limit: 1,
            limitFile: {
          accept: '.xls,.xlsx',
        },
            readAuto: true,
            bizType: "shipping",
            disabled: !hasTemplate.value,
            style: {"margin-top":"20px"}
          }, null, 8, ["limitFile", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["title", "visible"]),
    _createVNode(BindAmazonSkuModal, {
      visible: bindAmazonVisible.value,
      "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((bindAmazonVisible).value = $event)),
      item: rowItem.value,
      onSuccess: setAmazonInfo
    }, null, 8, ["visible", "item"])
  ]))
}
}

})